export const getLocalAvailabilityData = ({ state }) => state.masterCatalog.masterCatalogData;
export const getSelectedProduct = ({ state }) => state.masterCatalog.selectedProduct;
export const getProductLog = ({ state }) => state.masterCatalog.productLog;
export const getSelectedProductsItems = ({ state }) => state.masterCatalog.selectedProductsItems;
